const SliderData = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1546768292-fb12f6c92568?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    title: "Discover and Share Knowledge with a Global Community",
    text: "Engage in a knowledge-sharing platform where users can ask intriguing questions, share insights, and explore a vast repository of questions across diverse topics. Whether you're here to learn or to teach, there’s always something new to discover.",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1501446529957-6226bd447c46?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1489&q=80",
    title: "Create Custom Question Papers",
    text: "Design your own question papers with ease and share them with others for feedback and learning.",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
    title: "Collaborate and Engage",
    text: "Dive into discussions, gain feedback, and grow alongside like-minded learners. Whether answering questions or sharing your expertise, every interaction helps build a richer knowledge base for everyone involved.",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1475189778702-5ec9941484ae?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1351&q=80",
    title: "User-Centric, Seamless Experience",
    text: "Enjoy a clean, intuitive interface optimized for discovering, creating, and sharing knowledge at your pace."
  },
];

export { SliderData };
